import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { I18nProvider } from "./i18n";
import "./styles.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found");
}

createRoot(root).render(
  <StrictMode>
    <I18nProvider title={{ zh: "数据中心控制中心", en: "Data Center Control Center" }}>
      <App />
    </I18nProvider>
  </StrictMode>
);
